import { render, staticRenderFns } from "./FaxToEmailService.vue?vue&type=template&id=211a7c4a&scoped=true&"
import script from "./FaxToEmailService.vue?vue&type=script&lang=js&"
export * from "./FaxToEmailService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a7c4a",
  null
  
)

export default component.exports